//
//
//
//

import TimelineDripCampaign from "./timeline-drip-campaign";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "TimelineAutomation",
  components: {
    TimelineDripCampaign
  },
  props: {
    automationType: {
      type: String,
      required: true
    }
  }
});